import { PermissionChecker } from "@smart/bridge-permissions-basic";
import { globalTeamUri } from "@smart/bridge-types-basic";

import { GqlForm, GqlSetting } from "../form-builder/types";

export const filterDisplayableForms = ({
  forms,
  setting,
  permission,
}: {
  forms: GqlForm[] | undefined;
  setting: GqlSetting | null | undefined;
  permission: PermissionChecker | undefined;
}) => {
  const areasOfLaw = setting?.areasOfLaw?.map((area) => area.trim());
  return forms?.filter((form) => {
    const matchCategory = areasOfLaw?.length
      ? form.matterTypeCategories.some((category) =>
          areasOfLaw?.includes(category),
        )
      : true;
    const matchLocation = setting?.locations?.length
      ? form.matterTypeLocations.some((location) =>
          setting?.locations?.includes(location),
        )
      : true;
    const canAccessGlobal = permission?.can("add", {
      type: "form",
      value: { uri: form.uri, teamUri: globalTeamUri },
    });
    const isDisplayableGlobalForm = setting?.disableGlobalForms
      ? false
      : form.teamUri === globalTeamUri && (form.active || canAccessGlobal);
    const isTeamForm = form.teamUri !== globalTeamUri;

    return (
      matchCategory && matchLocation && (isTeamForm || isDisplayableGlobalForm)
    );
  });
};

export const hasCustomReminderMessage = (form: GqlForm) =>
  !!form.rawForm.values.clientMessages?.reminder;

export const countCustomReminderMessageForms = ({
  forms,
}: {
  forms: GqlForm[] | undefined;
}) => (forms ?? []).filter(hasCustomReminderMessage).length;
